// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.list-items",
        "codeId": "a18",
        "events": [
            {
                "eventTarget": ".email a",
                "eventType": "click",
                "tags": {
                    "componentId": "a18",
                    "componentName": "list items",
                    "elementType": "location item email link",
                    "event": "locator",
                    "eventType": "list items click to email",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "ul.list"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".title a",
                "eventType": "click",
                "tags": {
                    "componentId": "a18",
                    "componentName": "list items",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "location title link",
                    "event": "locator",
                    "eventType": "list items internal navigation click",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "ul.list"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".phone a",
                "eventType": "click",
                "tags": {
                    "componentId": "a18",
                    "componentName": "list items",
                    "elementType": "location item phone number link",
                    "event": "locator",
                    "eventType": "list items click to call",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "ul.list"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".web a",
                "eventType": "click",
                "tags": {
                    "componentId": "a18",
                    "componentName": "list items",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "location website link",
                    "event": "locator",
                    "eventType": "list items outbound click",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "ul.list"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": "",
                    //merged from chemicals
                    'event1': 'gaCustomEvents_distributor_locator',
                    'eventCategory': 'Customer Enablement & Education',
                    'eventAction': 'Visited Distributor Site',
                    'eventLabel': "",
                    'external_url': "",
                    'page_type': 'Distributor Page',
                    'page_title': 'Distributor Locator',
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",

                    //merged from chemicals

                }
            }]
    },
)